export default __webpack_public_path__ + "static/media/bubble_nova_logo.9a76beef.svg";